import React from 'react'

export default ({ label, name, options, onChange, errorMessage }) => (
    <>
        <div className='hw-label'>{label}</div>
        {options.map((option, index) => (
            <label
                key={index}
                className={`hw-checkbox ${
                    errorMessage ? 'hw-checkbox--error' : ''
                }`}
            >
                {option.text}
                <input
                    type='checkbox'
                    name={name}
                    value={option.value}
                    defaultChecked={option.checked}
                    onChange={onChange}
                />
                <i className='hw-checkbox__indicator'></i>
            </label>
        ))}
        {errorMessage && (
            <div className='hw-error-simple hw-error--align-left'>
                {errorMessage}
            </div>
        )}
    </>
)
